
var lastPropRow = $('.property-row').last();
var addBtn = $("#add-row");
var removeBtn = $("#remove-row");
var rowCount = 1;

$(addBtn).click(function(e){
  e.preventDefault();

  $(lastPropRow).after(
      '<div class="row property-row">' +
        '<div class="col-md-1">' +
          '<input type="number" name="property-order-' + rowCount + '" id="property-order-' + rowCount + '" class="form-control">' +
        '</div>' +
        '<div class="col-md-3">' +
          '<input type="text" name="property-name-' + rowCount + '" id="property-name-' + rowCount + '" placeholder="Property Name" class="form-control">' +
        '</div>' +
        '<div class="col-md-8">' +
          '<textarea name="property-value-' + rowCount + '" id="property-value-' + rowCount + '" placeholder="Property Value" cols="30" class="form-control property-textarea"></textarea>' +
        '</div>'+
      '</div>'
  );

  lastPropRow = $('.property-row').last();
  $(removeBtn).fadeIn();
  rowCount ++;

});

$(removeBtn).click(function(e){
  e.preventDefault();
  //make sure you don't remove the last row.
  if(rowCount > 1){
    //remove the last row
    $(lastPropRow).remove();

    //re set the last row variable
    lastPropRow = $('.property-row').last();

    //remove the "remove" button if there is only one row left
    if(rowCount == 2){
      //disable the remove row button
      $(removeBtn).fadeOut();
    }

    rowCount --;
  }
});